module.exports = new __parcel__URL__("list-merge-modal-dark.45013aa2.gif").toString();